import React from "react";
import { Box } from "@mui/material";
import PageHeader from "./PageHeader";
import BottomToolbar from "./BottomToolbar";
import { pageContentSx } from "../pageLayout";

// Layout estándar de pantalla: PageHeader (AppBar a ancho completo, con su
// contenido interno ya centrado a 980px) + área de contenido centrada a
// 980px + BottomToolbar opcional (ancho completo). Solo el chrome
// (appbars/bottom nav) va de punta a punta; el contenido de la pantalla no.
// Usar esto en pantallas nuevas en vez de repetir el patrón de
// pageContentSx a mano — eso es justamente lo que se desincronizó en varias
// pantallas (ver pageLayout.js).
const PageLayout = ({
  title,
  subtitle,
  avatarSrc,
  avatarIcon,
  avatarNode,
  rightSlot,
  showBottomNav = true,
  contentSx = {},
  children,
}) => (
  <Box sx={{ minHeight: "100vh" }}>
    <PageHeader
      title={title}
      subtitle={subtitle}
      avatarSrc={avatarSrc}
      avatarIcon={avatarIcon}
      avatarNode={avatarNode}
      rightSlot={rightSlot}
    />
    <Box sx={{ ...pageContentSx, mb: showBottomNav ? 10 : 4, ...contentSx }}>
      {children}
    </Box>
    {showBottomNav && <BottomToolbar />}
  </Box>
);

export default PageLayout;
